import { render, staticRenderFns } from "./HelpContact.vue?vue&type=template&id=19ddad98&scoped=true"
import script from "./HelpContact.vue?vue&type=script&lang=js"
export * from "./HelpContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ddad98",
  null
  
)

export default component.exports